import { useSearchParams } from "react-router"
import { useCustomerAudit } from "../../../api/customersApi"
import { AuditTrail } from "../../shared/AuditTrail"

export function CustomerAuditSection() {
  const [searchParams] = useSearchParams()
  const id = searchParams.get("id")

  const { data, hasNextPage, fetchNextPage, isLoading, isFetchingNextPage } =
    useCustomerAudit(id, { limit: 20 })

  const events = data?.pages.flatMap((p) => p.items) ?? []

  return (
    <AuditTrail
      events={events}
      isLoading={isLoading}
      hasMore={!!hasNextPage}
      isFetchingMore={isFetchingNextPage}
      onLoadMore={fetchNextPage}
    />
  )
}
